<!-- 课时管理 -->

<template>
  <div class="main">
    <back />
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索课时名称" suffix-icon="el-icon-search" v-model="lessonName" :clearable="true"
        @change="onSearch"></el-input>
      <el-select v-model="type" placeholder="选择课时类型" @change="onSearch" clearable>
        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="shelfStatus" placeholder="选择状态" @change="onSearch" clearable>
        <el-option v-for="item in shelfOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button class="btn" type="primary" @click="handleAdd">新增课时</el-button>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column min-width="150" show-overflow-tooltip prop="" label="课时序号">
            <template slot-scope="scope">
              <span>{{ `第${scope.row.sortNum}课时` }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="lessonName" label="课时名称"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip label="课时类型">
            <template slot-scope="scope">
              <div v-if="$route.query.costAttr == 1">
                <span v-if="scope.row.costAttr == 0">试看课时</span>
                <span v-if="scope.row.costAttr == 1">收费课时</span>
              </div>
              <div v-if="$route.query.costAttr == 0">
                <span>免费课时</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="relatedType" label="链接类型">
            <template slot-scope="scope">
              <span v-if="scope.row.relatedType == 3">文件</span>
              <span v-if="scope.row.relatedType == 2">直播</span>
              <span v-if="scope.row.relatedType == 1">视频</span>
            </template>
          </el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="points" label="奖励积分"></el-table-column>
          <el-table-column label="状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.onlineStatus" inactive-color="#E2E2E2"
                @change="changeOnlineStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="250" min-width="250" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="downloadTemplate(scope.row)"
                v-if="scope.row.relatedType == 3">下载文件</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleModify(scope.row)">编辑</el-button>
              <el-button size="small" class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    </div>

    <!-- 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="165px" class="demo-ruleForm">
        <el-row class="row">
          <el-col :span="12">
            <el-form-item label="课时序号：" prop="sortNum">
              <div class="item">
                <div class="txt">第</div>
                <!-- <el-input v-model="ruleForm.sortNum" placeholder="请输入" :disabled="dialogTitle == '修改课时'"></el-input> -->
                <el-input v-model="ruleForm.sortNum" placeholder="请输入"></el-input>
                <div class="txt">课时</div>
              </div>
            </el-form-item>
            <el-form-item label="课时类型：" prop="costAttr" v-if="$route.query.costAttr == 1">
              <el-select v-model="ruleForm.costAttr" placeholder="请选择" clearable>
                <el-option v-for="item in costAttrOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课时类型：" v-if="$route.query.costAttr == 0">
              <el-input value="免费课时" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="视频Url：" prop="vodPlayUrl" v-if="this.ruleForm.relatedType == 1">
              <el-input v-model="ruleForm.vodPlayUrl" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="积分奖励：" prop="points">
              <el-input v-model="ruleForm.points" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课时名称：" prop="lessonName">
              <el-input v-model="ruleForm.lessonName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="链接类型：" prop="relatedType">
              <el-select v-model="ruleForm.relatedType" placeholder="请选择" clearable @change="handleChange">
                <el-option :value="1" label="视频"></el-option>
                <el-option :value="2" label="直播"></el-option>
                <el-option :value="3" label="文件"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="视频ID：" prop="vodFileId" v-if="this.ruleForm.relatedType == 1">
              <el-input v-model="ruleForm.vodFileId" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="row" v-if="this.ruleForm.relatedType == 3">
          <el-col :span="14">
            <el-form-item label="上传文件" prop="playUrl">
              <el-upload :action="apiBaseUrl" :headers="apiHeaders" :file-list="importFiles"
                :before-upload="beforeUploads" :auto-upload="true" :limit="1" :on-exceed="handleExceed"
                :on-remove="handleRemove2" name="multipartFile" :on-success="handleSuccess"
                accept=".xlsx,.xls,.doc,.ppt,.docx,.pptx">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red">可上传doc, xls, ppt, pdf, docx, xlsx,
                  pptx文件，且不超过50MB</div>
              </el-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <div class="table" v-if="this.ruleForm.relatedType == 2">
          <div class="g_table">
            <el-table :data="tableData2" height="450" style="width: 100%" @row-click="singleElection"
              highlight-current-row>
              <el-table-column align="center" width="55" label="">
                <template slot-scope="scope">
                  <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                  <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column label="序号" width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
                </template>
              </el-table-column>
              <el-table-column min-width="290" show-overflow-tooltip prop="liveName" label="直播名称"></el-table-column>
              <el-table-column min-width="130" show-overflow-tooltip prop="price" label="直播价格(元)">
                <template slot-scope="scope">
                  <span>{{ scope.row.costAttr == 0 ? "免费" : scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="150" show-overflow-tooltip prop="teacherName"
                label="直播主讲专家"></el-table-column>
              <el-table-column min-width="180" show-overflow-tooltip prop="startTime" label="直播开始时间"></el-table-column>
              <el-table-column min-width="180" show-overflow-tooltip prop="endTime" label="直播结束时间"></el-table-column>
              <el-table-column min-width="130" show-overflow-tooltip prop="liveStatus" label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.liveStatus == 1">待开播</div>
                  <div v-if="scope.row.liveStatus == 2">直播中</div>
                  <div v-if="scope.row.liveStatus == 3">已结束</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagebox">
            <el-pagination background @current-change="handleCurrentChange2" @size-change="handleSizeChange2"
              :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2"
              layout="prev, pager, next, jumper,sizes, total" :total="totalItemsCount2"
              class="pg_input"></el-pagination>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog" type="primary" plain>取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      courseId: null,
      shelfStatus: "", // 选择上下架状态
      shelfOptions: [
        {
          value: "1",
          label: "上架",
        },
        {
          value: "0",
          label: "下架",
        },
      ],
      type: "", // 课时类型
      typeOptions: [
        {
          value: "1",
          label: "收费课时",
        },
        {
          label: "免费课时",
          value: 0,
        },
      ],
      lessonName: "",
      costAttr: null,
      // 表格数据
      tableData: [],
      costAttrOptions: [
        {
          label: "收费课时",
          value: 1,
        },
        {
          label: "免费课时",
          value: 0,
        },
      ], // 状态options
      // 弹窗数据
      dialogVisible: false, // 弹窗显隐
      dialogTitle: "", // 弹窗标题
      ruleForm: {
        sortNum: "",
        vodFileId: "",
        vodPlayUrl: "",
        lessonName: "",
        costAttr: "",
        points: "",
        relatedType: 1,

        playUrl: "",
        lessonFileId: "",
        fileName: "",

      },
      rules: {
        sortNum: [
          {
            required: true,
            message: "请输入课时序号",
            trigger: "blur",
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入数字",
            trigger: "blur",
          },
        ],
        lessonName: [
          {
            required: true,
            message: "请输入课时名称",
            trigger: "blur",
          },
        ],
        costAttr: [
          {
            required: true,
            message: "请选择课时类型",
            trigger: "blur",
          },
        ],
        playUrl: [
          {
            required: true,
            message: "请上传文件",
            trigger: "blur",
          },
        ],
        points: [
          {
            required: true,
            message: "请输入积分奖励",
            trigger: "blur",
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入数字",
            trigger: "blur",
          },
        ],
      },
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      //   当前选择的行的id
      templateSelection: "",
      tableData2: [],
      currentPage2: 1, // 当前页码
      pageSize2: 10, // 每页显示的行数
      pageSizeArr2: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）

      apiBaseUrl: this.$axios.defaults.baseURL + this.$api.uploadFile,
      apiHeaders: {
        token: this.$store.state.token,
      },
      importShow: false,
      importFiles: [], //文件列表
    }
  },
  created() {
    this.courseId = this.$route.query.id || null
    this.costAttr = this.$route.query.costAttr || null
    this.selectCourseLessonPage()
  },
  methods: {
    // 下载
    downloadTemplate(row) {
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = row.playUrl
      link.download = row.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    beforeUploads(file) {
      const suffixArr = ["doc", "xls", "ppt", "pdf", "docx", "xlsx", "pptx"];
      const maxSize = 1024 * 1024 * 50;
      const fileSuffix = file.name.split(".").pop().toLowerCase();
      if (!suffixArr.includes(fileSuffix)) {
        this.$message.error(`只能上传"${suffixArr.join('"、"')}"文件`);
        this.importFiles = [];
        return false;
      }
      if (file.size > maxSize) {
        this.$message.error("附件不能超过50MB");
        this.importFiles = [];
        return false;
      }
      // this.importFiles.push(file.raw);
      return true;
    },
    handleExceed() {
      this.$message.warning(`只能上传一个文件！`)
    },
    handleRemove2() {
      this.importFiles = []
      // 新增：删除文件时清空表单中的文件信息
      if (this.ruleForm.relatedType === 3) {
        this.ruleForm.playUrl = "";
        this.ruleForm.lessonFileId = "";
        this.ruleForm.fileName = "";
      }
    },
    handleSuccess(response) {
      this.ruleForm.playUrl = response.result.fileUrl
      this.ruleForm.lessonFileId = response.result.fileId
      this.ruleForm.fileName = response.result.fileName
    },
    // 获取列表
    selectCourseLessonPage() {
      this.loading = true
      this.$axios
        .get(this.$api.selectCourseLessonPage, {
          params: {
            lessonName: this.lessonName || null,
            courseId: this.courseId || null,
            onlineStatus: this.shelfStatus,
            costAttr: this.type,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData =
              res.result.list.map(e => {
                return {
                  ...e,
                  onlineStatus: e.onlineStatus == 1 ? true : false,
                }
              }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 获取列表
    selectLiveInfoPage() {
      this.$axios
        .get(this.$api.selectLiveInfoPage, {
          params: {
            liveName: this.liveName || null,
            liveStatus: this.status || null,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData2 = res.result.list || []
            this.totalItemsCount2 = res.result.totalCount
            if (this.ruleForm.liveId) {
              this.templateSelection = this.ruleForm.liveId
            }
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 上下架状态
    changeOnlineStatus(row) {
      const originalSwitch = row.onlineStatus
      this.$confirm(`确定${row.onlineStatus ? "上架" : "下架"}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateOnlineStatusLesson, {
              id: row.id,
              onlineStatus: row.onlineStatus ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "onlineStatus", originalSwitch)
              this.$message.success(res.desc)
              this.selectCourseLessonPage()
            })
            .catch(err => {
              this.$set(row, "onlineStatus", !originalSwitch)
              this.$message.error(err.desc)
              this.selectCourseLessonPage()
            })
        })
        .catch(() => {
          this.$set(row, "onlineStatus", !originalSwitch)
          this.selectCourseLessonPage()
        })
    },
    handleChange(value) {
      if (value == 1) {
        this.ruleForm.lessonFileId = ""
        this.ruleForm.fileName = ""
        this.ruleForm.playUrl = ""
        this.importFiles = []
      }
      if (value === 2) {
        this.ruleForm.lessonFileId = ""
        this.ruleForm.fileName = ""
        this.ruleForm.playUrl = ""
        this.importFiles = []

        this.ruleForm.vodPlayUrl = ""
        this.ruleForm.vodFileId = ""
        this.templateSelection = ""
        this.selectLiveInfoPage()
      } else {
        this.templateSelection = ""
      }
    },
    // 单选
    singleElection(row) {
      this.templateSelection = row.id
    },
    // 修改
    handleModify(row) {
      this.dialogVisible = true
      this.dialogTitle = "修改课时"
      this.ruleForm = JSON.parse(JSON.stringify(row))
      this.ruleForm.courseId = row.id
      if (this.ruleForm.relatedType == 2) {
        this.ruleForm.vodFileId = ""
        this.ruleForm.vodPlayUrl = ""
        this.selectLiveInfoPage()
      }

      if (this.ruleForm.relatedType === 3) {

        this.importFiles = [];

        const fileInfo = {
          name: row.fileName || '已上传文件',
          url: row.playUrl,
          raw: {},
          status: "success"
        };
        this.importFiles.push(fileInfo);
      }
    },
    // 新增
    handleAdd() {
      this.dialogTitle = "新增课时"
      this.dialogVisible = true
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.dialogTitle = ""
      this.resetForm()
    },
    // 表单校验
    submitForm(formName) {
      // 校验视频url和视频id两者之一必须有一项是必填
      if (this.ruleForm.relatedType === 1 && !this.ruleForm.vodFileId && !this.ruleForm.vodPlayUrl) {
        return this.$message.warning("视频Url和视频ID两者之一必须有一项是必填!")
      }

      if (this.ruleForm.relatedType === 2 && !this.templateSelection) {
        return this.$message.warning("请选择直播信息！")
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = {
            courseId: this.courseId || null,
            fileType: 1,
            vodFileId: this.ruleForm.vodFileId,
            lessonName: this.ruleForm.lessonName || null,
            sortNum: this.ruleForm.sortNum || null,
            costAttr: this.ruleForm.costAttr,
            points: this.ruleForm.points,
            vodPlayUrl: this.ruleForm.vodPlayUrl,
            relatedType: this.ruleForm.relatedType,
            liveId: this.templateSelection,

            playUrl: this.ruleForm.playUrl,
            lessonFileId: this.ruleForm.lessonFileId,
            fileName: this.ruleForm.fileName
          }

          if (this.dialogTitle == "修改课时") {
            formData.id = this.ruleForm.courseId
            this.$axios
              .post(this.$api.updateCourseLesson, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.handleCloseDialog()
                  this.selectCourseLessonPage()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 insertCourseLesson
            this.$axios
              .post(this.$api.insertCourseLesson, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.handleCloseDialog()
                  this.selectCourseLessonPage()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {
        sortNum: "",
        vodFileId: "",
        vodPlayUrl: "",
        lessonName: "",
        costAttr: "",
        relatedType: 1,
        playUrl: "",
        lessonFileId: "",
        fileName: ""
      };
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.importFiles = [];
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteCourseLesson, {
              params: {
                id: row.id,
              },
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.selectCourseLessonPage()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectCourseLessonPage()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectCourseLessonPage()
    },
    // -----直播-------
    handleSizeChange2(e) {
      this.pageSize2 = e
      this.onSearch2()
    },
    handleCurrentChange2(e) {
      this.tableData2 = []
      this.currentPage2 = e
      this.selectLiveInfoPage()
    },
    onSearch2() {
      this.clearData2()
      this.selectLiveInfoPage()
    },
    clearData2() {
      this.tableData2 = []
      this.currentPage2 = 1
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  .item {
    display: flex;

    .txt {
      color: #272727;
      font-size: 16px;
    }
  }

  ::v-deep .el-dialog .el-form-item .item .el-input {
    width: 125px !important;
    margin: 0 10px;
  }

  ::v-deep .el-dialog .el-form-item .item .el-input__inner {
    width: 125px !important;
  }

  .pagebox {

    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 90px;
      margin-right: 5px;
    }
  }
}
</style>
